import type { Signature } from '@/models/report';
import { formatSignatureDate } from '../../utils/formatDateTime';
import styles from './SignaturesSection.module.css';

interface SignaturesSectionProps {
  signatures: Signature[];
}

export default function SignaturesSection({
  signatures,
}: SignaturesSectionProps) {
  if (signatures.length === 0) return null;

  const sorted = [...signatures].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );

  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Signatures</h3>
      {sorted.map((sig) => {
        const name =
          `${sig.signerFirstName ?? ''} ${sig.signerLastName ?? ''}`.trim();
        return (
          <div key={sig.uuid} className={styles.signatureLine}>
            <span className={styles.signerName}>
              Dr. {name || 'Unknown'}, MD
            </span>
            <span className={styles.dot}>&middot;</span>
            <span className={styles.signedAt}>
              {formatSignatureDate(sig.createdAt)}
            </span>
          </div>
        );
      })}
    </section>
  );
}
